import { Component, output } from '@angular/core';
import { UiModule } from '../ui/ui.module';

@Component({
  selector: 'app-map-info-window-wrapper',
  templateUrl: './map-info-window-wrapper.component.html',
  styleUrls: [ './map-info-window-wrapper.component.scss' ],
  imports: [
    UiModule,
  ]
})
export class MapInfoWindowWrapperComponent {
  closeEvent = output<Event>();
}